import UserHOC from "../../../components/shared/HOC/UserHOC";
import { useDashboardData } from "../../../hooks/UserHooks/UserDashboradHook/useDashData";
import DashboardCards from "./components/DashboardCards";
import { formatDate } from "../../../utility/formatDate";
import { jwtDecode } from "jwt-decode";
import PageLoader from "../../../components/global/Loader/PageLoader";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserDashboard = () => {
  const auth = useSelector((state) => state.auth);
  const { stats, loading, deadlines } = useDashboardData(auth.id);
  const navigate = useNavigate();

  const handleDeadlineClick = (item) => {
    navigate(`/my-courses/course-content-user/${item.courseId}`);
  };

  if (loading) return <PageLoader visible={loading} />;
  return (
    <div className="bg-white rounded-[10px] contain-content p-6 shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] flex flex-col gap-5">
      <div>
        <p className="font-medium text-base text-[#464646]">Welcome to LMS</p>
        <p className="font-medium text-[28px] text-[#E74860]">{auth.fullName}</p>
      </div>
      <DashboardCards data={stats} />

      {deadlines?.length > 0 && (
        <div className="w-full rounded-[10px] shadow-[0_0_6px_0_#0000000D]">
          <div className="bg-[#F3F4F5] p-4 rounded-t-[10px]">
            <p className="font-medium text-[16px] text-[#2F2F2F]">Deadlines</p>
          </div>

          <div className="p-4 flex flex-col gap-2">
            {deadlines?.map((item) => {
              return (
                <div
                  key={item.courseId}
                  onClick={() => handleDeadlineClick(item)}
                  className="flex p-4 justify-between border border-[#F0F0F0] rounded-[10px] cursor-pointer hover:bg-[#F9F9F9] transition-colors"
                >
                  <p className="text-[#464646] font-normal text-[14px]">
                    {" "}
                    {item.title}{" "}
                  </p>
                  <p className="text-[#464646] font-normal text-[14px]">
                    {formatDate(item.deadline)}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserHOC(UserDashboard);